var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      class: [_vm.rootClasses],
      attrs: { tabindex: "-1", focusable: "false" }
    },
    [
      _c("title", { domProps: { textContent: _vm._s(_vm.symbol) } }),
      _vm._v(" "),
      _c("use", _vm._b({}, "use", { "xlink:href": _vm.symbolName }, false))
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-326e2ec8", { render: render, staticRenderFns: staticRenderFns })
  }
}